import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatApiErrorDetail } from "@/api/client";
import { Eye, EyeOff } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      if (u.role === "driver") nav("/driver");
      else if (u.role === "report_viewer") nav("/admin/reports");
      else nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  const switchLang = (l) => { i18n.changeLanguage(l); localStorage.setItem("lang", l); };

  return (
    <div className="login-shell">
      <div className="login-card" data-testid="login-card">
        <div className="login-brand">
          <div className="brand-mark" style={{ width: 44, height: 44, fontSize: 18 }}>SH</div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 20 }}>StepHub HR</div>
            <div style={{ fontSize: 12, color: "#64748B" }}>{t("common.loginTitle")}</div>
          </div>
        </div>
        <form onSubmit={submit}>
          <div className="field">
            <label className="label">{t("common.email")}</label>
            <input data-testid="login-email" className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" />
          </div>
          <div className="field">
            <label className="label">{t("common.password")}</label>
            <div className="input-with-eye">
              <input
                data-testid="login-password"
                className="input"
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="eye-btn"
                data-testid="login-pw-toggle"
                onClick={() => setShowPw((v) => !v)}
                aria-label={showPw ? "hide password" : "show password"}
              >
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          {error && <div data-testid="login-error" style={{ color: "#DC2626", fontSize: 13, marginBottom: 10 }}>{error}</div>}
          <button data-testid="login-submit" className="btn btn-primary btn-lg btn-block" type="submit" disabled={busy}>
            {busy ? t("common.loading") : t("common.login")}
          </button>
        </form>
        <div className="lang-toggle" style={{ marginTop: 16, justifyContent: "center" }}>
          <button className={i18n.language === "ja" ? "active" : ""} onClick={() => switchLang("ja")}>日本語</button>
          <button className={i18n.language === "en" ? "active" : ""} onClick={() => switchLang("en")}>English</button>
        </div>
      </div>
    </div>
  );
}
